export const SUPERSET_NEWSLETTER_FORM_ID =
  "ba525f61-6f7a-4219-b418-5318ee660a7f"
export const BLOG_SUBSCRIPTION_FORM_ID = "9cd609ca-6350-4264-81ba-1ea292dbd1f9"
export const TUTORIAL_GATING_FORM_ID = "503efdec-b0ae-4942-b5c5-d002ebbd9b44"
